import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [showMenuDropdown, setShowMenuDropdown] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const menuItems = [
    { path: '/student-enquiries', label: 'Student Enquiries' },
    { path: '/tutor-enquiries', label: 'Tutor Enquiries' },
    { path: '/students', label: 'Students' },
    { path: '/tutors', label: 'Tutors' },
    { path: '/accounts', label: 'Accounts' },
    { path: '/grievances', label: 'Grievances' }
  ];

  // Get user initials
  const getInitials = () => {
    if (!user?.username) return 'U';
    const parts = user.username.split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return user.username.substring(0, 2).toUpperCase();
  };

  return (
    <nav className="navbar">
      <Link to="/" className="navbar-logo">
        <svg className="logo-icon" width="28" height="28" viewBox="0 0 24 24" fill="none">
          <path d="M12 3L1 9L12 15L21 10.09V17H23V9M5 13.18V17.18L12 21L19 17.18V13.18L12 17L5 13.18Z" fill="#00BFA5"/>
        </svg>
        <h2>Sai Tutorials</h2>
      </Link>
      <div className="navbar-nav">
        <Link to="/" className={`nav-link-dashboard ${isActive('/')}`}>
          Dashboard
        </Link>
        <div
          className="nav-dropdown"
          onMouseEnter={() => setShowMenuDropdown(true)}
          onMouseLeave={() => setShowMenuDropdown(false)}
        >
          <span className="nav-link-menu">
            Menu
            <svg className="menu-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M7 10L12 15L17 10H7Z" fill="currentColor"/>
            </svg>
          </span>
          {showMenuDropdown && (
            <div className="dropdown-menu">
              {menuItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`dropdown-item ${isActive(item.path)}`}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          )}
        </div>
        <div
          className="profile-dropdown"
          onMouseEnter={() => setShowProfileDropdown(true)}
          onMouseLeave={() => setShowProfileDropdown(false)}
        >
          <div className="profile-button">
            <div className="profile-avatar">{getInitials()}</div>
            <span className="profile-name">{user?.username || 'User'}</span>
            <svg className="profile-arrow-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M7 10L12 15L17 10H7Z" fill="currentColor"/>
            </svg>
          </div>
          {showProfileDropdown && (
            <div className="profile-dropdown-menu">
              <div className="profile-info">
                <div className="profile-info-name">{user?.username || 'User'}</div>
                <div className="profile-info-email">{user?.email || 'user@example.com'}</div>
              </div>
              <div className="profile-divider"></div>
              {user?.role === 'admin' && (
                <>
                  <Link to="/users" className="profile-dropdown-item">
                    User Management
                  </Link>
                  <div className="profile-divider"></div>
                </>
              )}
              <Link to="/metadata" className="profile-dropdown-item">
                Settings
              </Link>
              <div className="profile-divider"></div>
              <button onClick={logout} className="profile-dropdown-item profile-logout">
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
